'use client'

import { cn } from '@/lib/utils'
import { UtensilsCrossed, ExternalLink } from 'lucide-react'
import { useTranslations } from 'next-intl'

interface MenuBlockContent {
  type: 'link' | 'pdf'
  url?: string
  title?: string
}

interface MenuBlockProps {
  content: MenuBlockContent
  className?: string
}

export function MenuBlock({ content, className }: MenuBlockProps) {
  const t = useTranslations('venue')
  if (!content.url) return null

  return (
    <div className={cn('', className)}>
      <a
        href={content.url}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(
          'flex items-center gap-4 p-4 rounded-xl',
          'bg-gradient-to-r from-zinc-800/80 to-zinc-800/40',
          'border border-zinc-700/50 hover:border-violet-500/30',
          'transition-all hover:shadow-lg hover:shadow-violet-500/5',
          'group'
        )}
      >
        <div className="p-3 rounded-lg bg-violet-500/20 text-violet-400 group-hover:bg-violet-500/30 transition-colors">
          <UtensilsCrossed className="h-6 w-6" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-white group-hover:text-violet-300 transition-colors">
            {content.title || t('viewMenu')}
          </p>
          <p className="text-sm text-zinc-500">
            {content.type === 'pdf' ? t('opensPdf') : t('opensInNewTab')}
          </p>
        </div>
        <ExternalLink className="h-5 w-5 text-zinc-500 group-hover:text-violet-400 transition-colors flex-shrink-0" />
      </a>
    </div>
  )
}
